import React, { useState, useEffect } from 'react';
import styles from './viewReferenceCheck.module.scss';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Route, Switch, Redirect, NavLink } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { useParams, useHistory } from 'react-router-dom';
import Avatar from 'react-avatar';
import CSSLoader from '../../../shared/cssLoader';
import { getReferenceCheckTask } from '../../../../services/util/referenceCheck';
import { submitReferenceCheckTask } from '../../../../services/util/referenceCheck';
import { rejectReferenceCheckTask } from '../../../../services/util/referenceCheck';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../../customNavbar';
import { CustomButton } from '../../../shared/customButton';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomConfirmationBox } from '../../../shared/customConfirmationBox';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import CandidateCvView from '../../common/candidateCvView';
import CandidateCoverLetterView from '../../common/candidateCoverLetterView';
import CandidateAnswersToCustomQuestionsView from '../../common/candidateAnswersToCustomQuestionsView';
import AddCandiateNoteModal from '../../common/addCandidateSpecialNoteModal';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const ViewReferenceCheck = (props) => {
    let [numPages, setNumPages] = useState(null);
    let [pageNumber, setPageNumber] = useState(1);
    let [isLoading, setLoading] = useState(false);
    const [isSubmit, setSubmit] = useState(false)
    const [isModalOpen, setModalOpen] = useState(false);
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [isURLLoading, setURLLoading] = useState(false);
    const [isRejectModalOpen, setRejectModalOpen] = useState(false);
    let [emptyNameError, setEmptyNameError] = useState(false);
    let [emptyFeedbackError, setEmptyFeedbackError] = useState(false);


    let [state, setState] = useState([]);
    let { id } = useParams();
    let [candidateValues, setCandidateValues] = useState({
        candidate_id: '',
        candidate_first_name: '',
        candidate_last_name: '',
        cv_url: null,
        cover_letter_url: null,
        evaluation_criteria: '',
        pipeline_stage_name: '',
        cv_review_session_id: null,
        custom_question_answers: []
    });
    const [cvObject, setCVObject] = useState({ url: null })
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);

    let history = useHistory();
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };
    const breadcrumb = [
        {
            pathaddress: '/app/company/reference-checks',
            pathname: 'Reference Checks',
            isActive: false,
            key: 2 + 'Reference Check'
        },
        {
            pathaddress: '',
            pathname: candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name,
            isActive: true,
            key: 3 + 'Reference Check'
        },
    ]

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView
    }

    const schema = yup.object({
        feedback: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required("Required"),
        reference_name: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required("Required"),
        reference_company: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        reference_title: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
    });



    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }

    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }

    //on adding comments function
    const onSubmit = async (values, { resetForm }) => {
        setEmptyNameError(false)
        setEmptyFeedbackError(false)
        setState(state => ([...state, {
            feedback: values.feedback,
            reference_name: values.reference_name,
            reference_company: values.reference_company,
            reference_title: values.reference_title,

        }]))
        resetForm({ feedback: '' });
        resetForm({ reference_name: '' });
        resetForm({ reference_company: '' });
        resetForm({ reference_title: '' });
    }

    //remove comment function
    function removeComment(index) {
        state.splice(index, 1)
        setState([...state])
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    function checkValidationAndOpenModal() {
        if (state.length > 0) {
            setModalOpen(true)
        } else {
            if (state.length === 0) {
                setEmptyFeedbackError(true)
                setEmptyNameError(true)
            }
        }
    }

    //Reject candidate
    function onClickReject() {
        if (state.length > 0) {
            setRejectModalOpen(true)
        } else {
            if (state.length === 0) {
                setEmptyFeedbackError(true)
                setEmptyNameError(true)
            }
        }
    }




    //submit values function
    async function submitValues() {
        if (state.length > 0) {
            setSubmit(true)
            let respond = await submitReferenceCheckTask(id, state)
            if (respond.success === true) {
                props.GetTaskValues();
                history.push(`/app/company/reference-checks/group?step_id=${candidateValues.step_id}`);
                setSubmit(false);
            } else {
                setSubmit(false);
            }
        } else {
            if (state.length === 0) {
                setEmptyFeedbackError(true);
                setEmptyNameError(true);
            }
        }
    }

    //submit reject values function
    async function submitRejectValues(values) {
        if (state.length > 0) {
            setSubmit(true)
            let respond = await rejectReferenceCheckTask(id, state, values.reason)
            if (respond.success === true) {
                props.GetTaskValues();
                history.push(`/app/company/reference-checks/group?step_id=${candidateValues.step_id}`);
                setSubmit(false);
            } else {
                setSubmit(false);
            }
        } else {
            if (state.length === 0) {
                setEmptyFeedbackError(true);
                setEmptyNameError(true);
            }
        }
    }

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon);
    }


    //load user values
    const getReferenceCheckDetails = async () => {
        setLoading(true)
        let respond = await getReferenceCheckTask(id)
        if (respond.success === true) {
            await setCandidateValues(respond.data)
            await setCVObject({
                url: respond.data.cv_url
            })
            setLoading(false)
        } else {
            setLoading(false)
            history.push('/app/company/reference-checks')
        }
    }

    //open and close note modal
    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }


    useEffect(() => {
        getReferenceCheckDetails();
    }, []);


    useEffect(() => {
        let pageHit = '/app/company/reference-checks';
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }


    return (
        <div>
            <Helmet>
                <title>CV Review | HireTrace</title>
            </Helmet>
            {!candidateValues.cv_url && isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    {/* submit result alert confirmation start */}
                    <CustomConfirmationModal
                        show={isModalOpen}
                        confirmationType='success'
                        cancelIconclick={() => setModalOpen(false)}
                        onSecondaryBtnClick={() => setModalOpen(false)}
                        onPrimaryBtnClick={submitValues}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="Your feedback cannot change later"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit result alert confirmation end */}

                    {/* submit result alert confirmation start */}
                    {
                        <CustomConfirmationBox
                            show={isRejectModalOpen}
                            cancelIconclick={() => setRejectModalOpen(false)}
                            onSecondaryBtnClick={() => setRejectModalOpen(false)}
                            onFormSubmit={submitRejectValues}
                            isSecondaryBtnDisabled={isSubmit === true ? true : false}
                            isPrimaryBtnDisabled={isSubmit === true ? true : false}
                            primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                            preCheckedCondition={true}
                            topic="Are you sure?"
                            message={`You are trying to reject the candidate.`}
                            secondaryBtnName="backBtn"
                            secondaryBtnType="button"
                            secondaryBtnCssType="defaultBtn"
                            secondaryBtnLabel="Cancel"
                            primaryBtnName="submitRejectBtn"
                            primaryBtnType="submit"
                            primaryBtnCssType="dangerBtn"
                            primaryBtnLabel="Yes, reject candidate"
                        />}
                    {/* submit result alert confirmation end */}

                    {/* open add note modal */}
                    {specialNoteModalOpen &&
                        <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={candidateValues.candidate_id} />
                    }
                    {/* close add note modal */}

                    {/* Alert Box End */}
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    {/* <Row className={styles.bodyRow}>
                        <Col md={7} lg={8} xl={9} className={styles.leftSideRow}> */}

                    {/* candidate review details */}
                    <Row>
                        <Col>
                            <div className={styles.reviewDetails}>
                                <Row>
                                    <Col md={1} lg={1} xl={1} className={styles.candidatePhoto}>
                                        <Avatar src={candidateValues.candidate_photo_url} name={candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name} size="90" round={false} />
                                    </Col>
                                    <Col md={11} lg={11} xl={11} className={styles.candidateDetails}>
                                        <Row>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Name : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name}</span> <i onClick={() => viewCandidate(candidateValues.candidate_id)} class="fas fa-external-link-alt ml-1S" id={styles.openInNewtabIcon}></i> </p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Email : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_email}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Mobile : </span><span className={styles.reviewDetailsValue}>{`(${candidateValues.candidate_mobile_country_code}) ${candidateValues.candidate_mobile_number}`}</span></p>
                                            </Col>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue}>{candidateValues.pipeline_name}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue}>{candidateValues.hiring_position}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Passing Threshold : </span><span className={styles.reviewDetailsValue}>Pass | Fail</span></p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Review Criteria : </span><span className={styles.reviewDetailsValue}>{candidateValues.evaluation_criteria}</span></p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className={styles.reviewAreaBox}>
                                <Col>
                                    <Row >
                                        <Col md={7} lg={8} xl={9} className={styles.reviewAreaLeft}>


                                            {/* view cv , cover letter and Custom Questions  */}
                                            <Tabs
                                                defaultActiveKey="cv"
                                                id="controlled-tab-example"
                                                className={styles.tabGroup}
                                            >
                                                <Tab eventKey="cv" title="CV" tabClassName={styles.tabItem} >

                                                    <CandidateCvView candidateValues={candidateValues} stepId={id} cvURL={candidateValues.cv_url} candidateID={candidateValues.candidate_id}
                                                    />
                                                </Tab>
                                                {candidateValues.cover_letter_url ? <Tab eventKey="CoverLetter" title="Cover Letter" tabClassName={styles.tabItem}>
                                                    <CandidateCoverLetterView candidateValues={candidateValues} stepId={id} coverLetterURL={candidateValues.cover_letter_url} candidateID={candidateValues.candidate_id} />
                                                </Tab> : null}
                                                {candidateValues.custom_question_answers && candidateValues.custom_question_answers.length > 0 ?
                                                    <Tab eventKey="customQuestions" title="Custom Questions" tabClassName={styles.tabItem}>
                                                        <CandidateAnswersToCustomQuestionsView candidateValues={candidateValues} />
                                                    </Tab> : null}
                                            </Tabs>
                                        </Col>
                                        <Col className={styles.reviewSubmissionColumn} md={5} lg={4} xl={3}>

                                            <Card className={styles.reviewSubmissionCard}>
                                                <Card.Header className={styles.reviewSubmissionCardHeader}>
                                                    <div className={styles.reviewSubmissionCardheaderDetails}>
                                                        <p className={styles.reviewSubmissionCardHeaderTopic}>Submit Feedback</p>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body>
                                                    <div className={styles.addNoteDiv}>
                                                        <p className={styles.noteValue} onClick={() => openSpecialNoteModal()}>Add special note</p>
                                                    </div>
                                                    <Formik
                                                        validationSchema={schema}
                                                        onSubmit={(values, resetForm) => onSubmit(values, resetForm)}
                                                        initialValues={{}}>

                                                        {({
                                                            values,
                                                            errors,
                                                            setFieldValue,
                                                            handleChange,
                                                            handleSubmit,
                                                            resetForm
                                                        }) => (


                                                            <div>
                                                                <Form noValidate onSubmit={handleSubmit}>

                                                                    <Form.Group controlId="reference_name">
                                                                        <Form.Label className={styles.textfieldLabel}>Name</Form.Label>
                                                                        <Form.Control type="text" name="reference_name" value={values.reference_name || ''} onChange={(e) => { setFieldValue('reference_name', e.target.value); }} isInvalid={errors.reference_name || emptyNameError} onFocus={() => setEmptyNameError(false)} className={styles.textfield} />
                                                                        <p className={styles.errorMessageComments}>{errors.reference_name}</p>
                                                                    </Form.Group>
                                                                    <Form.Group controlId="reference_company">
                                                                        <Form.Label className={styles.textfieldLabel}>Company</Form.Label>
                                                                        <Form.Control type="text" name="reference_company" value={values.reference_company || ''} onChange={(e) => { setFieldValue('reference_company', e.target.value); }} className={styles.textfield} />
                                                                    </Form.Group>
                                                                    <Form.Group controlId="reference_title">
                                                                        <Form.Label className={styles.textfieldLabel}>Title</Form.Label>
                                                                        <Form.Control type="text" name="reference_title" value={values.reference_title || ''} onChange={(e) => { setFieldValue('reference_title', e.target.value); }} className={styles.textfield} />
                                                                    </Form.Group>
                                                                    <Form.Group controlId="feedback">
                                                                        <Form.Label className={styles.textareaLabel}>Feedback</Form.Label>
                                                                        <Form.Control as="textarea" name="feedback" value={values.feedback || ''} onChange={(e) => { setFieldValue('feedback', e.target.value); }} rows={3} className={styles.textareaBox} isInvalid={errors.feedback || emptyFeedbackError} onFocus={() => setEmptyFeedbackError(false)} />
                                                                        <p className={styles.errorMessageComments}>{errors.feedback}</p>
                                                                    </Form.Group>
                                                                    {(emptyFeedbackError === true && !errors.feedback) &&
                                                                        <p className={styles.errorMessageSubmit}> You must add at least one reference check feedback.</p>
                                                                    }
                                                                    <div>
                                                                        <CustomButton
                                                                            id="add_comment"
                                                                            buttonType="submit"
                                                                            label="Add Comment"
                                                                            type="secondaryBtn"
                                                                            frontIcon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                <path d="M9.99984 4.22156V15.8882M4.1665 10.0549H15.8332" stroke="#2790A6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>}
                                                                            handleClick={handleChange}
                                                                        />
                                                                    </div>
                                                                    <p className={styles.commentsLabel}>Comments About Candidate</p>

                                                                    <div className='mb-1 pb-1'>
                                                                        {state.length > 0 && state.map((item, i) => (
                                                                            <Row className='m-0 p-1'>
                                                                                <Col sm={11} className='m-0 p-0'>
                                                                                    <Card className={styles.commentBox} key={i}>
                                                                                        <Card.Body className={styles.commentBoxBody}>
                                                                                            <span className={styles.commentsInnerBox}>
                                                                                                <span className={styles.commentValue}>{item.reference_name}</span>
                                                                                                <span className={styles.commentValue}>{item.reference_company}</span>
                                                                                                <span className={styles.commentValue}>{item.reference_title}</span>
                                                                                                <span className={styles.commentValue}>{item.feedback}</span>
                                                                                            </span>
                                                                                        </Card.Body>
                                                                                    </Card>
                                                                                </Col>
                                                                                <Col sm={1} className={styles.reviewCommentSecondCol}>
                                                                                    <span className={styles.cancelIconDiv} onClick={() => removeComment(i)} key={(props.keyValue) + 1}>
                                                                                        <svg className={styles.cancelIcon} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g id="trash-01">
                                                                                                <path id="Icon" d="M13.3333 5.49999V4.83332C13.3333 3.8999 13.3333 3.43319 13.1517 3.07667C12.9919 2.76307 12.7369 2.5081 12.4233 2.34831C12.0668 2.16666 11.6001 2.16666 10.6667 2.16666H9.33333C8.39991 2.16666 7.9332 2.16666 7.57668 2.34831C7.26308 2.5081 7.00811 2.76307 6.84832 3.07667C6.66667 3.43319 6.66667 3.8999 6.66667 4.83332V5.49999M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.49999H17.5M15.8333 5.49999V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5608C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5608C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.49999" stroke="#B42318" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </g>
                                                                                        </svg>
                                                                                    </span>
                                                                                </Col>
                                                                            </Row>
                                                                        ))
                                                                        }

                                                                    </div>

                                                                </Form>
                                                            </div>
                                                        )}
                                                    </Formik>

                                                    <div>
                                                        <CustomButton
                                                            buttonType="submit"
                                                            type="primaryBtn"
                                                            label="Submit and Pass to Next Step"
                                                            disabled={isSubmit === true ? true : false}
                                                            handleClick={checkValidationAndOpenModal}
                                                        />
                                                    </div>

                                                    <div style={{ marginTop: '10px' }}>
                                                        <CustomButton
                                                            buttonType="submit"
                                                            type="dangerBtn"
                                                            label="Submit and Reject"
                                                            disabled={isSubmit === true ? true : false}
                                                            handleClick={onClickReject}
                                                        />
                                                    </div>

                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>
                    </Row>

                </div>)
            }
        </div >
    )
}

export default ViewReferenceCheck;
